const countryCurrency = {
  "GB": "UK",
};


document.addEventListener('DOMContentLoaded', function() {

  window.updateComfortPoints = function() {
    var comfort_point_div = document.querySelector(".comfort_point_div");
    if(comfort_point_div){
        comfort_point_div.classList.add('loading');
        fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
            // console.log(data);
            var totalPrice = Number(data.total_price) / 100;
            var comfortPointsPerDollar = 10;
            var comfortPointsEarned = Math.round(totalPrice / comfortPointsPerDollar);
    
            //console.log("Total Comfort Points Earned:", comfortPointsEarned);
            var chkComfortPoints = document.querySelector('.chkComfortPoints');
            var chkComfort_text = document.querySelector('.chkComfortPoints').getAttribute("data-comfort-point-text");
            if (chkComfort_text) {
              var replacementText = chkComfort_text.replace('comfort_points', '<strong>' + comfortPointsEarned + '</strong>');
              chkComfortPoints.innerHTML = replacementText;
              //console.log("all ok");
            }
            comfort_point_div.classList.remove('loading');
          })
          .catch(error => {
            console.error('Error fetching cart total:', error);
          });
    }
   
  }
  
  updateComfortPoints();
});




//shipping
document.addEventListener('DOMContentLoaded', function() {

  const freeShippingCard = document.querySelector(".free-shipping-progress-card");
  if(freeShippingCard){
  const messageCart = document.querySelector(".message-cart");
  const shippingElement = document.querySelector('.shipping.cart-footer-details');
  const calculateShippingDifference = (totalCartValue, freeShippingThreshold) => totalCartValue - freeShippingThreshold;

  const getShippingMessage = (shippingDifference, shippingSymbol, shippingCountryCode, modifiedCartMessage) => {
    const dataFreeShippingfulfill = messageCart.getAttribute("data-shipping-fulfill");
    if (shippingDifference >= 0) {
      freeShippingCard.classList.remove("free-shipping-in-progress");
      freeShippingCard.classList.add("free-shipping-bar");
      if (window.location.href.indexOf('cart') !== -1) {
          if (shippingElement) {
             shippingElement.classList.remove('hidden');
          }
      }

      return `${dataFreeShippingfulfill}${shippingCountryCode ? ` in the ${shippingCountryCode}.` : ""}`;
    } else {
      freeShippingCard.classList.remove("free-shipping-bar");
      freeShippingCard.classList.add("free-shipping-in-progress");
      if (window.location.href.indexOf('cart') !== -1) {
          if (shippingElement) {
             shippingElement.classList.add('hidden');
          }
      }
      return modifiedCartMessage;
    }
  };

  window.updateCartForShippingProgress = function(){
    if(freeShippingCard){freeShippingCard.classList.add('loading');}
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const dataFreeShipping = messageCart.getAttribute("data-free-shipping");
        const totalPriceFromCart = Number(data.total_price) / 100;
        const freeShippingUK = Number(dataFreeShipping);
        const shippingSymbol = document.querySelector("header").getAttribute("data-currency-symbol");
        const shippingCountry = freeShippingCard.getAttribute("data-country");
        const cartMessage = messageCart.getAttribute("data-text");
        const countryName = shippingCountry;
        let shippingCountryCode = "";
        if (countryCurrency.hasOwnProperty(countryName)) {
          shippingCountryCode = countryCurrency[countryName];
        } else {
          //console.log("Currency symbol not found for the given country.");
        }
        const shippingDifference = calculateShippingDifference(totalPriceFromCart, freeShippingUK);
        const modifiedCartMessage = cartMessage.replace("Free_shipping_progress", `<b>${shippingSymbol}${Math.abs(shippingDifference.toFixed(2))}</b>`);
        const shippingMessage = getShippingMessage(shippingDifference, shippingSymbol, shippingCountryCode, modifiedCartMessage);"shippingMessage", shippingMessage
        //console.log("shippingMessage", shippingMessage)
        const progressBar = document.querySelector('.text-progress');
        const freeShipping__Card = document.querySelector(".free-shipping-progress-card");
  
        progressBar.innerHTML = `<div>${shippingMessage}</div>`;
        //console.log("progressBar.innerHTML" , progressBar , progressBar.innerHTML);
        freeShipping__Card.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error fetching cart total:', error);
      });
  };
  updateCartForShippingProgress();
  }
});


// Function to calculate total saving from elements with class .saving-heading
window.calculateTotalSaving = function() {
if (window.location.href.includes("cart")) {
    var savingPrices = document.querySelector('.saving-heading');
    var subTotalAmout_with_savings = document.querySelector('.sub-total .bold');
    let totalSaving = 0;
    var savingString = savingPrices.getAttribute('data-cart-total-saving');
    var subTotalAmout_with_savings_attribute = savingPrices.getAttribute('data-subtotal-plus-saving');
    //console.log("savingString", savingString);
    const savingTotalElement = document.querySelector('.saving-total-price');
    if(savingTotalElement){
    savingTotalElement.textContent =  savingString;
    subTotalAmout_with_savings.textContent = subTotalAmout_with_savings_attribute;
    }
}
}
window.calculateTotalSaving();

//tooltips
function toggleTooltip(element) {
    var parent = element.closest('.tooltip-parent');
    if (!parent) return; // Exit if no parent with class 'tooltip-parent' found
    var position = parent.getBoundingClientRect().top;
    var tooltip = parent.querySelector('.tooltip');

    // Hide all tooltips first
    var allTooltips = document.querySelectorAll('.tooltip');
    allTooltips.forEach(function(item) {
        item.style.display = 'none';
    });

    // Check if the element is closer to the top or bottom of the viewport
    if (position >= window.innerHeight / 2) {
        tooltip.classList.remove("tooltipTop");
        tooltip.classList.add("tooltipBottom");
        element.classList.remove("anchor-top");
        element.classList.add("anchor-bottom");
    } else {
        tooltip.classList.remove("tooltipBottom");
        tooltip.classList.add("tooltipTop");
        element.classList.add("anchor-top");
        element.classList.remove("anchor-bottom");
    }

    tooltip.style.display = 'block';

    // Add mouseout event to the tooltip
    tooltip.addEventListener('mouseout', function(e) {
        hideTooltip(element);
    });
}

function hideTooltip(element) {
    var parent = findTooltipParent(element);
    if (!parent) return;

    var tooltip = parent.querySelector('.tooltip');
    if (!tooltip) return;

    tooltip.style.display = 'none';
    element.classList.remove("anchor-top", "anchor-bottom");
}

function findTooltipParent(element) {
    var parent = element.parentNode;
    while (parent) {
        if (parent.classList.contains('tooltip-parent')) {
            return parent;
        }
        parent = parent.parentNode;
    }
    return null;
}



//custom validation
$(document).ready(function() {
  var dobWrapper = $('#RegisterForm-DOB');
  var monthIndex; // Declare monthIndex outside of the event listeners
  var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var today = new Date();
  var obj = {
    day: today.getDate(),
    month: today.getMonth() + 1,
    year: today.getFullYear()
  };
  setDate(today);
  var dateStr = obj.year + "-"  + obj.month + "-" + obj.day;
  // dobWrapper.val(dateStr);
  var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  setMonth(month);
  setYears(100, "YYYY");
  $("body").on('change', '#select-month', function() {
    var monthIndex = parseInt($(this).val()) - 1; // Subtract 1 to convert to zero-based index
    obj.month = $('#select-month option:selected').text();
    obj.day = $('#select-day option:selected').text();
    obj.year = $('#select-year option:selected').text();
    updateDate();
    checkAge();
    setDays(monthIndex);
    dobValidation();
    
  }).on('change', '#select-day', function() {
    obj.day = $('#select-day option:selected').text();
    obj.month = $('#select-month option:selected').text();
    obj.year = $('#select-year option:selected').text();
    updateDate();
    checkAge();
    dobValidation();
    //console.log(obj);
  }).on('change', '#select-year', function() {
    var selectedMonth = $('#select-month').val();
    if (selectedMonth) {
      monthIndex = selectedMonth - 1;
      obj.year = $(this).val();
      obj.day = $('#select-day option:selected').text();
      obj.month = $('#select-month option:selected').text();
      updateDate();
      setDays(monthIndex); 
    }
    
  checkAge();
  dobValidation();
  });

  function setDate(date) {
    //console.log(date.getMonth());
    setDays(date.getMonth());
    $("#select-day").val("DD");
    $("#select-month").val(date.getMonth() + 1);
    $("#select-year").val(date.getFullYear());
    $("#select-month").change(); // Trigger change event to update dateStr
  }

  function updateDate() {
   // console.log("Updating date...");
    var dateStr = obj.year + "-"  + obj.month + "-" + obj.day;
    dobWrapper.val(dateStr);
  }

  function setDays(monthIndex) {
    //console.log("Month index: " + monthIndex);
    if (monthIndex < 0 || monthIndex > 11) {
      console.error("Invalid month index: " + monthIndex);
      return;
    }
    var optionCount = $('#select-day option').length;
    var daysCount = daysInMonth[monthIndex];
    if (monthIndex === 1) { 
      let selectedYear = Number($("#select-year option:selected").val());
      daysCount = isLeapYear(selectedYear) ? 29 : 28;
     // console.log("Days in February: " + daysCount);
    }
    if (optionCount < daysCount) {
      for (var i = optionCount; i <= daysCount; i++) {
        $('#select-day').append($("<option></option>").attr("value", i).text(i));
      }
    } else {
      for (var i = daysCount; i <= optionCount; i++) {
        var optionItem = '#select-day option[value=' + (i + 1) + ']';
        $(optionItem).remove();
      }
    }
  }

  function isLeapYear(year) {
    var leapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    //console.log(year + " is a leap year: " + leapYear);
    return leapYear;
  }

  function setYears(range, defaultYear, monthIndex) {
    var year = today.getFullYear() - range;
    var endYear = today.getFullYear();
    for (var i = endYear; i >= year; i--) {
      var option = $("<option></option>").attr("value", i).text(i);
      if (i === defaultYear) {
        option.attr("selected", "selected");
      }
      setDays(monthIndex)
      $('#select-year').append(option);
    }
     setDays(monthIndex);
  }

  function setMonth(val) {
    for (let index = 0; index < val.length; index++) {
      $('#select-month').append($("<option></option>").attr("value", index + 1).text(val[index]).attr("data-value", val[index]));
    }
  }

  function checkAge() {
    var dob = new Date(obj.year, obj.month - 1, obj.day); 
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var monthDiff = today.getMonth() - dob.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
    }

    if (age < 18) {
        $(".error-age").remove(); 
        var errorDiv = '<div class="error-age">You must be at least 18 years old to register.</div>';
        $(".field.select-margin").append(errorDiv);
    } else {
        $(".error-age").remove(); 
    }
}
}); 

$(document).ready(function(){
  // dobValidation();
  })
  
  function dobValidation(){
    let age = 18;
    let birthDate = $('#select-day').val();
    let birthMonth = $('#select-month').val();
    let birthYear = $('#select-year').val();
    var todaysDate = new Date();
    todaysDate.setFullYear(todaysDate.getFullYear() - age);
    var usersBirthDay = new Date();
    var bm = birthMonth;
    var bd = birthDate;
    var by = birthYear;
    if(isNaN(bm) || isNaN(bd) || isNaN(by)){
      errorMsgContainer("You must be at least 18 years old to register.");
      return ;
    }
    usersBirthDay.setFullYear(by, bm - 1, bd);
    if ((todaysDate - usersBirthDay) < 0) {
      errorMsgContainer("You must be at least 18 years old to register.");
      obj_status.dob = false;
      // validation_status(obj_status,form_selectors);
    } else {
      $(".error-message").remove(); 
      obj_status.dob = true;
      // validation_status(obj_status,form_selectors);
    }
  }

  // erro message container
  function errorMsgContainer(msg){
     $(".error-message").remove(); // Remove any existing error message
      var errorDiv = `<div class="error-message">${msg}</div>`;
      $(".field.select-margin").append(errorDiv);
  }
/**toggle**/document.addEventListener('DOMContentLoaded', function() {
   // Hide all tab content except the first one
   var tabContents = document.querySelectorAll('.tab-content .tab-pane');
   for (var i = 1; i < tabContents.length; i++) {
      tabContents[i].style.display = 'none';
   }

   // Handle click event on tab links
   var tabLinks = document.querySelectorAll('.nav-tabs .nav-item a');
   for (var i = 0; i < tabLinks.length; i++) {
      tabLinks[i].addEventListener('click', function(e) {
         e.preventDefault();
         var tabId = this.getAttribute('href');
         // Hide all tab content
         for (var j = 0; j < tabContents.length; j++) {
            tabContents[j].style.display = 'none';
         }
         // Show the clicked tab content
         document.querySelector(tabId).style.display = 'block';
      });
   }
});


/**tabs**/
document.addEventListener('DOMContentLoaded', function () {
    const tabsButtons = document.querySelectorAll('.nav-item:not(.back)');
    const tabsContents = document.querySelectorAll('.tab-pane');
    const tabsBack = document.querySelectorAll('.nav-item.back');
    const stickyHeader = document.querySelector('.shopify-section-header-sticky');

    if (!tabsButtons.length) return;

    // Hide all tab contents initially
    tabsContents.forEach(content => content.style.display = 'none');

    // Hide all back buttons initially
    tabsBack.forEach(backBtn => backBtn.style.display = 'none');

    // Function to handle tab switching
    function handleTabClick(button) {
        const itemId = button.getAttribute('aria-controls');

        // Hide all tab buttons and remove active class
        tabsButtons.forEach(btn => {
            btn.style.display = 'none';
            btn.classList.remove('active');
        });

        // Show the selected tab content and scroll to it
        tabsContents.forEach(content => {
            if (content.getAttribute('id') === itemId) {
                content.style.display = 'block';
                button.style.display = 'flex';
                button.classList.add('active');

                if (window.location.pathname.includes('/products/')) {
                    scrollToContent(content);
                } else {
                    scroll_function("#delivery-Subtab");
                }

                // Show all back buttons
                tabsBack.forEach(backBtn => backBtn.style.display = 'flex');
            }
        });
    }

    // Function to handle back button click
    function handleBackClick() {
        tabsContents.forEach(content => content.style.display = 'none');
        tabsButtons.forEach(button => {
            button.style.display = 'block';
            button.classList.remove('active');
        });
        tabsBack.forEach(backBtn => backBtn.style.display = 'none');
    }

    // Function to scroll to content while considering sticky header
    function scrollToContent(content) {
        let headerHeight = stickyHeader ? stickyHeader.offsetHeight + 200 : 0;
        const scrollPosition = content.getBoundingClientRect().top + window.scrollY - headerHeight;
        
        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    }

    // Attach event listeners
    tabsButtons.forEach(button => button.addEventListener('click', () => handleTabClick(button)));
    tabsBack.forEach(backBtn => backBtn.addEventListener('click', handleBackClick));
});



//account menu

      document.addEventListener("DOMContentLoaded", function() {

    var login_account = document.querySelector(".login-account");
    var close_button = document.querySelector(".close_account_button");
    var dropDownContainer = document.querySelector('.dropdown-menu.LoginDrop');
    var dropdownLinks = document.querySelectorAll('.dropdown-menu.LoginDrop li.dropdown-li .linkHover');
    
    if (login_account) {
        login_account.addEventListener("click", function(event){
            event.preventDefault(); 
            dropDownContainer.classList.toggle("show");
        });
    }
    
    if (dropdownLinks) {
        dropdownLinks.forEach(function(link) {
            link.addEventListener('click', function(event) {
                event.preventDefault(); 
                var href = this.getAttribute('href');
                localStorage.setItem('lastClickedHref', href); 
                window.location.href = "/account"; 
            });
        });
    }
    
    document.addEventListener('click', function(event) {
      if(dropDownContainer){
        if (!dropDownContainer.contains(event.target) && !login_account.contains(event.target)) {
            dropDownContainer.classList.remove("show");
        }
      }
    });
     close_button.addEventListener('click', function(event) {
      if(dropDownContainer){
        dropDownContainer.classList.remove("show");
      }
    });

    var lastClickedHref = localStorage.getItem('lastClickedHref');
    if (lastClickedHref) {
        var profileLink = document.querySelector('.profile-navigation li a[href="' + lastClickedHref + '"]');
        if (profileLink) {
            profileLink.click(); 
            localStorage.removeItem('lastClickedHref'); 
        }
    }

});



//cart Section Api
window.cartDrawerUpdate = function(){
$.ajax({
    url: '/?section_id=cart-drawer',
    type: 'GET',
    dataType: 'html',
    success:function(carthtml) {
      $('cart-drawer').html($(carthtml).find('cart-drawer').html());
      setTimeout(() => {
    	document.querySelector(".drawer").classList.remove("is-empty");
    	document.querySelector(".drawer").classList.add("animate");
    	document.querySelector(".drawer").classList.add("active");
        closeEvent();
    }, 100);
    setTimeout(() => {
    	updateCartForShippingProgress();
    }, 1500);
    }
});
}

function closeEvent(){
 document.querySelector('#CartDrawer-Overlay').addEventListener('click', function (){
   document.querySelector(".drawer").classList.remove('active');
 });
}




/**affliate page**/

let headerHeight = $('.shopify-section-group-header-group').outerHeight();

$('.html-affiliates .rich-text-affiliates').on('click', function(event) {
   event.preventDefault();
  scroll_function('#multicolumn-affiliates--template--17726183243939__multicolumns_with_image_ijdicr');
});

$('.html-affiliates .banner__buttons').on('click', function(event) {
  event.preventDefault(); // Prevent the default anchor behavior
  scroll_function('#multicolumn-affiliates--template--17726183243939__multicolumns_with_image_ijdicr');
});

/**ambasdar page**/

$('.html-ambassador .banner__buttons a').on('click', function(event) {
   event.preventDefault();
  scroll_function('#shopify-section-template--17726410719395__ambassador_form_xjVaKe');
});
/**review**/
$('.product__info-wrapper .review_section_link').on('click', function(event) {
   event.preventDefault();
  scroll_function('#allReviews');
});


function scroll_function(href) {
  setTimeout(function() {
    const headerHeight = $('.shopify-section-header-sticky').outerHeight();
    $('html, body').animate({
      scrollTop: $(href).offset().top - headerHeight
    }, 500);
  }, 100); 
}




/**cc point update on variant change**/
document.addEventListener("DOMContentLoaded", function() {
  const headerElement = document.querySelector(".header");
  const currencySymbol = headerElement ? headerElement.getAttribute("data-currency-symbol") : null;

  document.querySelectorAll(".block__cb input").forEach(function(input_button) {
    input_button.addEventListener("change", function() {
      const label = input_button.nextElementSibling;
      if (label && label.tagName.toLowerCase() === "label") {
        const amountElement = label.querySelector(".prvw_totalAmount_wrapper h4 .money");
        if (amountElement) {
          let amountText = amountElement.textContent.trim();
          if (currencySymbol && amountText.startsWith(currencySymbol)) {
            amountText = Number(amountText.replace(currencySymbol, '').trim());
          }
          let points = Math.round(amountText / 10);
          document.querySelector('.prod_customer_points').innerText = `${points}`;
        }
      }
    });
  });
});

//  document.addEventListener("DOMContentLoaded", function () {
//    const swiperElements = document.querySelectorAll(".wishlist-swiper");
//    swiperElements?.forEach((each) => {
//       if (each) { 
//         const swiperss = new Swiper(each, {
//           slidesPerView: 1.2,
//           spaceBetween: 10,
//           dots: true,
//           navigation: {
//             nextEl: ".swiper-button-nxt",
//             prevEl: ".swiper-button-prv",
//           },
//         });
//       }     
//    })
// })

document.addEventListener("DOMContentLoaded", function () {
    let swiperInstance = null;  // Store the Swiper instance globally

    function initializeSwiper() {
        // Only initialize Swiper if it's mobile (width < 1024px)
        if (window.innerWidth <= 750 && !swiperInstance) {
            const swiperElements = document.querySelectorAll(".wishlist-swiper");
            swiperElements.forEach((each) => {
                if (each) {
                    // Initialize Swiper for mobile devices
                    swiperInstance = new Swiper(each, {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                        navigation: {
                            nextEl: ".swiper-button-nxt",
                            prevEl: ".swiper-button-prv",
                        },
                        pagination: {
                            el: ".swiper-pagination", // Enable pagination (dots)
                            clickable: true,
                        },
                    });
                }
            });
        }
    }

    function destroySwiper() {
        // If Swiper instance exists and the width is above 750px, destroy the instance
        if (swiperInstance && window.innerWidth > 750) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;  // Reset the Swiper instance
        }
    }

    // Initialize Swiper on DOM content loaded
    initializeSwiper();

    // Listen to window resize to destroy Swiper on desktop and reinitialize on mobile
    window.addEventListener("resize", function () {
        destroySwiper(); // Destroy swiper on desktop
        initializeSwiper(); // Reinitialize swiper on mobile
    });
});






